import { useTranslation } from 'react-i18next';

import { BaseModalContainer } from '@nw/shared/ui';
import { sendGAEventToDataLayer } from '@nw/shared/utils';

import { CloudWatchEventNames } from '../../constants/CloudWatchEventConstants';
import { useNiatApplicationMachineContext } from '../../context/NiatApplicationMachineProvider';

import {
  CancelButtonStyle,
  CancelPaymentConfirmationModalButtons,
  CancelPaymentConfirmationModalButtonsContainer,
  ConfirmButtonStyle,
  PaymentCancelConfirmationModalContainer,
  PaymentCancelConfirmationText
} from './styledComponents';

export const JusPayPaymentCancelConfirmationModal = (props) => {
  const { t } = useTranslation();
  const { niatApplicationMachineSend } = useNiatApplicationMachineContext();

  const { isModalOpen, onCloseConfirmationModal } = props;

  const handleClickOnYes = (): void => {
    sendGAEventToDataLayer({
      event: 'payment_cancelled'
    });
    niatApplicationMachineSend({
      type: 'LOG_CLOUD_WATCH',
      eventName: CloudWatchEventNames.PAYMENT_CANCELLED,
      eventType: 'user_action'
    });
    onCloseConfirmationModal(true);
  };

  const handleClickOnNo = (): void => {
    onCloseConfirmationModal();
  };

  return (
    <BaseModalContainer
      isModalOpen={isModalOpen}
      baseModalContainerStyles="jusPayPaymentCancelConfirmationModalStyles"
      hideCloseIcon={true}
    >
      <PaymentCancelConfirmationModalContainer>
        <PaymentCancelConfirmationText>
          {t('payment.wantToCancelThePayment')}
        </PaymentCancelConfirmationText>

        <CancelPaymentConfirmationModalButtonsContainer>
          <CancelPaymentConfirmationModalButtons
            onClick={handleClickOnNo}
            css={CancelButtonStyle}
          >
            {t('payment.no')}
          </CancelPaymentConfirmationModalButtons>
          <CancelPaymentConfirmationModalButtons
            onClick={handleClickOnYes}
            css={ConfirmButtonStyle}
          >
            {t('payment.yes')}
          </CancelPaymentConfirmationModalButtons>
        </CancelPaymentConfirmationModalButtonsContainer>
      </PaymentCancelConfirmationModalContainer>
    </BaseModalContainer>
  );
};
